export default __webpack_public_path__ + "ui/assets/img/bitmap@2x.png";